(function () {
  'use strict';

  function initializeNewInsolePage() {
    var root = document.querySelector('.new-insole-product');
    if (!root || root.dataset.insoleLayoutInitialized === 'true') return;

    root.dataset.insoleLayoutInitialized = 'true';

    var gallery = root.querySelector('.gallery__default');
    var thumbnails = gallery
      ? Array.prototype.slice.call(gallery.querySelectorAll('.gallery__thumbnail'))
      : [];
    var previousImageButtons = gallery
      ? Array.prototype.slice.call(gallery.querySelectorAll('[data-insole-gallery-previous]'))
      : [];
    var nextImageButtons = gallery
      ? Array.prototype.slice.call(gallery.querySelectorAll('[data-insole-gallery-next]'))
      : [];
    var currentImageLabels = gallery
      ? Array.prototype.slice.call(gallery.querySelectorAll('[data-insole-gallery-current]'))
      : [];

    function activeThumbnailIndex() {
      var activeIndex = thumbnails.findIndex(function (thumbnail) {
        return thumbnail.classList.contains('bstrSlider__thumb--active');
      });

      return activeIndex < 0 ? 0 : activeIndex;
    }

    function updateGalleryControls() {
      if (!thumbnails.length) return;

      var activeIndex = activeThumbnailIndex();
      currentImageLabels.forEach(function (label) {
        label.textContent = String(activeIndex + 1);
      });
      previousImageButtons.forEach(function (button) {
        button.disabled = activeIndex === 0;
      });
      nextImageButtons.forEach(function (button) {
        button.disabled = activeIndex === thumbnails.length - 1;
      });
    }

    function selectGalleryImage(offset) {
      var nextIndex = Math.max(0, Math.min(thumbnails.length - 1, activeThumbnailIndex() + offset));
      var nextThumbnail = thumbnails[nextIndex];
      if (!nextThumbnail) return;

      nextThumbnail.click();
      nextThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      window.setTimeout(updateGalleryControls, 0);
    }

    previousImageButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectGalleryImage(-1);
      });
    });

    nextImageButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectGalleryImage(1);
      });
    });

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        window.setTimeout(updateGalleryControls, 0);
      });
    });

    if (thumbnails.length) {
      var galleryObserver = new MutationObserver(updateGalleryControls);
      galleryObserver.observe(gallery.querySelector('.gallery__thumbnails'), {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
      updateGalleryControls();
    }

    var productForm = root.querySelector('#product--page form');
    var buyButton = productForm && productForm.querySelector('[data-buy-button]');
    if (!buyButton) return;

    var buttonText = buyButton.querySelector('[data-button-text]');

    root.querySelectorAll('.product__description p').forEach(function (paragraph) {
      if (paragraph.textContent.indexOf('Now available for pre-order') !== -1) {
        paragraph.classList.add('new-insole-preorder-source');
      }
    });

    function updatePurchaseButton() {
      if (!buttonText) return;

      var currentText = buttonText.textContent.trim();
      if (
        buyButton.disabled ||
        /^(make a selection|choose fit and size|choose a size|add to cart)$/i.test(currentText)
      ) {
        if (currentText !== 'Add to Cart') buttonText.textContent = 'Add to Cart';
      }
    }

    updatePurchaseButton();

    var observer = new MutationObserver(updatePurchaseButton);
    observer.observe(buyButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });

    productForm.addEventListener('click', function () {
      window.setTimeout(updatePurchaseButton, 0);
    });

    productForm.addEventListener('change', function () {
      window.setTimeout(updatePurchaseButton, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeNewInsolePage);
  } else {
    initializeNewInsolePage();
  }

  document.addEventListener('booster:content:update', initializeNewInsolePage);
})();
